/** Created by azhou on 2019/4/26.*/
<template>
    <div>
      <public-title>度假产品{{queryCon.mainId?'套餐':''}}列表
        <el-button slot="right" class="ml-auto" type="primary" size="small" @click="addEditProduct">{{queryCon.mainId?'添加套餐':'添加产品'}}</el-button>
      </public-title>
      <div class="load-area">
        <el-tabs v-model="activeName" @tab-click="$GFUN.pageChange(1);getDataLists()" v-show="!queryCon.mainId">
          <el-tab-pane :name="item.id" v-for="item in tabArr" :key="item.id" :label="item.name" />
        </el-tabs>
        <el-tabs class="topTab" v-model="activeName" @tab-click="$GFUN.pageChange(1);getDataLists()" v-show="queryCon.mainId">
          <el-tab-pane :name="item.id" v-for="item in mealArr" :key="item.id" :label="item.name" />
        </el-tabs>
        <product-calendar v-if="activeName=='3'" />
        <div v-else>
          <p v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</p>
          <div v-else>
            <ul class="list-head mt-3">
              <li class="w-50" v-for="item in titleArr" :key="item">
                {{item}} <i class="el-icon-edit text-link" v-show="item === '排序'" @click="changeSort"></i>
              </li>
            </ul>
            <ul class="list-item" v-for="(item,index) in AdminDataLists.lists" :key="item.id">
              <li class="w-50 list-item-col">
                <el-popover placement="right" trigger="hover">
                    {{item.title}}<span slot="reference">{{item.title | formatString(10)}}</span>
                </el-popover>
              </li>
              <li class="w-50 list-item-col">{{item.date_in | formatTimestamp}} 至 {{item.date_out | formatTimestamp}}</li>
              <li class="w-50 list-item-col" v-show="!queryCon.mainId">{{item.count_nums}}个</li>
              <li class="w-50 list-item-col flex-column">
                <span>原价：&yen; {{item.price1 | formatMoney}} 元</span>
                <span>抢购价：&yen; {{item.price2 | formatMoney}} 元</span>
                <span>结算价：&yen; {{item.price3 | formatMoney}} 元</span>
              </li>
              <li class="w-50 list-item-col" v-show="queryCon.mainId">
                <span v-if="!showSortInput">{{item.sort}}</span>
                <el-input class="w-50" v-else v-model="AdminDataLists.lists[index].sort"></el-input>
              </li>
              <li class="w-50 list-item-col" v-show="!queryCon.mainId">{{item.time | formatTimestamp(1)}}</li>
              <li class="w-50 list-item-col">{{item.browse_num}}</li>
              <li class="w-50 list-item-col">{{item.relay_num}}</li>
              <li class="w-50 list-item-col">{{item.order_nos}}</li>
              <li class="w-50 list-item-col">{{item.success_order_nos}}</li>
              <li class="w-50 list-item-col" v-show="!queryCon.mainId">
                <span v-if="item.status == 0">下架</span>
                <span v-else>上架</span>
              </li>
              <li class="w-50 list-item-col" v-show="queryCon.mainId">
                <span v-if="item.is_up == 1" class="text-primary">主产品</span>
                <el-button size="small" type="primary" v-else @click="setDefault(item)">设为主产品</el-button>
              </li>
              <li class="w-50 list-item-col-end flex-wrap">
                <span class="text-link" @click="changeProduct(item)" v-show="!queryCon.mainId">查看</span>
                <span class="text-link mr-2" @click="addEditProduct(item)" v-show="queryCon.mainId">编辑</span>
                <span class="text-link" @click="soldOutProduct(item)" v-show="queryCon.mainId">{{item.status ? '下架' : '上架'}}</span>
              </li>
            </ul>
            <el-pagination background layout="prev, pager, next" class="mt-4"
              :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
              @current-change="$GFUN.pageChange"/>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import { mapState,mapGetters, mapActions } from 'vuex'
  import ProductCalendar from './ProductCalendar.vue'

  export default {
    name: 'ProductLists',
    components: {
      ProductCalendar
    },
    computed: {
      ...mapState(['AdminDataLists']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      titleArr() {
        if (!this.queryCon.mainId) return ['产品名称','使用时间','套餐数','价格','添加时间','浏览','转发','下单','购买','状态','操作']
        else return ['套餐名称','使用时间','价格','排序','浏览','转发','下单','购买','状态','操作'];
      },
    },
    data() {
      return {
        activeName:'1',
        tabArr:[{id:'1',name:'已上架'},{id:'0',name:'未上架'}],
        mealArr: [{id:'1',name:'已上架'},{id:'0',name:'未上架'},{id:'3',name:'产品日历'}],
        showSortInput:false,
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
      }
    },
    watch:{
      queryCon(newval) {
        if (JSON.stringify(newval) == "{}") {
          this.activeName = '1'
        }
        this.queryCon.page = Number(newval.page)
        this.getDataLists();
      },
    },
    created() {
      this.getDataLists();
    },
    mounted() {
      document.querySelector('.bg-base').setAttribute('style', 'background-color:#fff!important')
    },
    methods:{
      ...mapActions(['getAdminDataLists','sortProduct','setProductDefault','editProduct']),
      //获取度假产品列表
      getDataLists() {
        let data = {
          ...this.queryCon,
          status:this.activeName
        }
        if (this.activeName == '3') {
          data.status = ''
        }
        if (!this.queryCon.mainId) data.is_up = '1';
        else data.main_id = this.queryCon.mainId;
        this.getAdminDataLists({ type:'productList', data });
      },
      //添加编辑度假产品
      addEditProduct(item) {
        this.$router.push({
          name:'addEditProduct',
          query:{
            mainId:this.$route.query.mainId,
            proId:item.id
          }
        })
      },
      //查看度假产品的套餐
      changeProduct(item) {
        this.$router.push({
          name:this.$route.name,
          query:{
            ...this.$route.query,
            mainId:item.main_id,
            page: 1
          }
        })
      },
      //修改套餐排序
      changeSort() {
        if (this.showSortInput) {
          this.sortProduct({
            main_id:this.queryCon.mainId,
            sort_arr:this.AdminDataLists.lists.map(v => {
              return {
                product_id:v.id,
                sort:v.sort
              }
            })
          })
        }
        this.showSortInput = !this.showSortInput;
      },
      //设置套餐为主套餐
      setDefault(item) {
        this._confirm('确定将该套餐设置为主产品么？',() => {
          this.setProductDefault({
            data:{
              main_id:this.queryCon.mainId,
              product_id:item.id
            },
            successFun:this.getDataLists
          })
        })
      },
      //套餐下架
      soldOutProduct(item) {
        this._confirm(`确定将该套餐${item.status ? '下架' : '上架'}么？`,() => {
          this.editProduct({
            data:{
              ...item,
              product_id:item.id,
              status:item.status ? '0' : '1'
            },
            successFun:this.getDataLists
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.el-tabs__nav-wrap::after{
  background-color: #fff!important
}
</style>
